import withDraft from '@/utils/draftHelper';
import { removeItemByCode } from '@/utils/resultsHelper';
import actions from '@/collections/constants';
import { datasetLists } from '../constants';
import { updateDatasetListCollectionsState } from './state';

const updateDatasetListCollections = withDraft((draft, { result }) => {
  updateDatasetListCollectionsState(draft, result);
});

const saveCollectionImageSuccess = withDraft((draft, { code, imageKey }) => {
  updateDatasetListCollectionsState(draft, { code, imageKey });
});

const destroyDatasetListCollections = withDraft((draft, { items }) => {
  datasetLists.forEach((category) => {
    const datasets = draft.datasets[category]?.results || [];
    datasets.forEach((dataset) => {
      if (dataset?.collections) {
        items.forEach((collection) => {
          // eslint-disable-next-line no-param-reassign
          dataset.collections = removeItemByCode(dataset.collections, collection);
        });
      }
    });
  });
});

export default {
  [actions.DESTROY_COLLECTION]: destroyDatasetListCollections,
  [actions.SAVE_COLLECTION_IMAGE_SUCCESS]: saveCollectionImageSuccess,
  [actions.UPDATE_COLLECTION_SUCCESS]: updateDatasetListCollections,
};
